import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  AddCountryAction,
  UpdateCountryAction,
} from "store/middlewares/dataManagement/country";
import {
  // Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import { SubmitLoaderButton } from "components/atoms";

function ModalEditCountry({ row }) {
  const dispatch = useDispatch();

  //--------------------- image change function ------------------------------
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    const updateValue = { ...values, name: values.name.trim() };

    let tempObj = { ...updateValue, countryCode: `+${values.countryCode}`,onSuccess: () => formik.setSubmitting(false),
    onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    }, };
    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,
      };
      dispatch(UpdateCountryAction(tempObj));
    } else {
      dispatch(AddCountryAction(tempObj));
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      countryCode: row?.country_code.replace("+", "") ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Country name is required")
        .min(3, "Minimum 3 characters required"),
      countryCode: Yup.string().required("Country code is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  // useEffect(() => {
  //   console.log(formik.errors);
  // }, [formik]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Country</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter name"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Country Code</Label>
              <Input
                error={formik.errors.countryCode && formik.touched.countryCode}
                errorMsg={formik.errors.countryCode}
                value={formik.values.countryCode}
                type="text"
                isSpace={true}
                isNumeric={true}
                name="countryCode"
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("countryCode", onlyNumbers);
                }}
                maxLength={5}
                onBlur={formik.handleBlur}
                placeholder="Enter country code"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              {/* <Button type={"submit"}>{row ? "Update" : "Add"}</Button> */}
              <SubmitLoaderButton
                 btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}      
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditCountry;
